import React, { useEffect, useContext, useState, useMemo, useRef } from 'react'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import { hasAccesPermits, exportDataComponent } from 'core/utils'
import Grid, {
  freeEditEngine,
  flexGridRenderer,
  // defaultFlexColHeaderRenderer,
  defaultFlexCellRenderer,
  FlexColHeader,
} from '@integec/grid-tools'
import {
  getApiTargetInfo,
  ExportComponent,
  getEnvConfig,
  getPermitActions,
} from 'core'
import { connect } from 'react-redux'
import {
  getPiMonSumm,
  savePiMonSumm,
  finalizePiMonSumm,
  getWindPlantInfo,
} from 'api/pgads.js'
import { message, Button, Select, Input, DatePicker } from 'antd'
import { SpinContext, DatePickerContext, ErrorContext } from 'context'
import * as ScreenPermissions from 'core/EventActions'
import {
  getHeader,
  getReadOnlyCols,
  getBlackColsSet,
  getMapEditRow,
} from './clientWise'
import R from 'ramda'
const PiMonthlysummary = ({
  apiTargetInfo,
  envConfig,
  actionPermits,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const CLIENT_ID = envConfig.clientId
  const readOnlyCols = getReadOnlyCols(CLIENT_ID)
  const blackColsSet = getBlackColsSet(CLIENT_ID)
  const headers = getHeader(CLIENT_ID)
  const mapEditRow = getMapEditRow(CLIENT_ID)

  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)

  const [data, setData] = useState([])

  const [plantId, setPlantId] = useState()
  const [utility, setUtility] = useState()
  const [utilityMap, setUtilityMap] = useState({})
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )

  const hasPiMonthlySummaryAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PI_WRITE_MONTHLY_SUMMARY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const isEditable = ({ header }) =>
    hasPiMonthlySummaryAccess && !readOnlyCols.includes(header.ident)

  const editRow = editInfo => {
    const modData = data.map(d => {
      if (editInfo.updatedMap.get(d)) {
        return {
          ...editInfo.updatedMap.get(d),
          // modificationInfo: { user: null, modDate: moment() },
          modificationInfo: undefined,
          updated: true,
        }
      } else {
        return d
      }
    })

    let editData = editInfo.updated
    editData = editData.map(d => ({
      ...d,
      // modificationInfo: { user: null, modDate: moment() },
      modificationInfo: undefined,
    }))
    setData(modData)
    setEditInfo({ ...editInfo, updated: editData })
    // this.setState({
    //   data: modData,
    //   editInfo: { ...editInfo, updated: editData },
    // })
  }

  const toYearMonth = date => ({
    year: date.format('YYYY'),
    month: date.format('MM'),
  })

  useEffect(
    _ => {
      getWindPlantInfo(apiTargetInfo).fork(setError, data => {
        // setWindUtility(ob(data.map(d => d.utility)))
        const unm = data
          .map(d => ({ [d.plantIdName]: d.utility }))
          .reduce((a, b) => ({ ...a, ...b }))
        setUtilityMap(unm)
      })
    },
    [apiTargetInfo, setError]
  )

  const onRetrieve = _ => {
    if (utility === undefined || utility.length === 0) {
      message.warning('Please Select Plant')
      return
    }
    setSpinning(true)
    getPiMonSumm(apiTargetInfo)({
      // year: date.format('YYYY'),
      // month: date.format('MM'),
      ...toYearMonth(selectedDate),
      plantId,
      utility,
    }).fork(setError, data => {
      setSpinning(false)
      setEditInfo(freeEditEngine.generateInitialEditInfo())
      setData(data)
    })
  }

  const onSave = _ =>
    savePiMonSumm(apiTargetInfo)(data.filter(d => d.updated)).fork(
      setError,
      _ => {
        message.info('Data Saved')
        onRetrieve()
      }
    )

  const onfiniliazeData = _ => {
    if (utility === undefined || utility.length === 0) {
      message.warning('Please Select Plant')
      return
    }
    if (editInfo.updated.length > 0) {
      message.warning("Please 'Save' the data before you Finalize")
      return
    }
    const req = {
      ...toYearMonth(selectedDate),
      plantId,
      utility,
    }
    setSpinning(true)
    // eslint-disable-next-line no-unused-vars
    finalizePiMonSumm(apiTargetInfo)(req).fork(setError, d => {
      setSpinning(false)
      message.info('Data Finalized')
    })
  }

  const monSummHeaderRenderer = props => {
    const staticBgColor = 'rgba(96, 87, 87)'
    if (blackColsSet.includes(props.header.ident))
      return (
        <FlexColHeader backgroundColor={staticBgColor} width={props.width}>
          <div
            style={{
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.85em',
              lineHeight: '1.3em',
              borderRight: '1px solid #ccc',
              flex: '0 0 100px',
              width: '100px',
            }}
          >
            {props.header.display}
          </div>
        </FlexColHeader>
      )
    else
      return (
        <FlexColHeader backgroundColor="#eee" width={props.width}>
          <div>{props.header.display}</div>
        </FlexColHeader>
      )

    // return defaultFlexColHeaderRenderer(props)
  }

  const gridCellRenderer = props => {
    const staticBg = 'rgba(179,172,15,.13)'
    const selectionBg = 'rgba(87,83,86,.5)'
    const hoverBg = 'rgba(168,172,1,.25)'
    const hoverSelectionBg = 'rgba(168,172,169,.85)'
    const staticColor = 'brown'
    const finalProps = readOnlyCols.includes(props.header.ident)
      ? {
          ...props,
          backgroundColor: staticBg,
          color: staticColor,
          hoverSelectionColor: staticColor,
          hoverBackgroundColor: hoverBg,
          hoverColor: staticColor,
          selectionBackgroundColor: selectionBg,
          selectionColor: staticColor,
          fontWeight: 'bold',
          hoverSelectionBackgroundColor: hoverSelectionBg,
        }
      : props

    return defaultFlexCellRenderer(finalProps)
  }

  const gridRenderer = (apiTargetInfo, heightOffSet, widthOffSet) =>
    flexGridRenderer({
      headerRowHeight: 40,
      width: widthOffSet,
      height: heightOffSet,
      autoFixColByKey: true,
      colHeaderRenderer: props => monSummHeaderRenderer(props), // => <div>are we here?</div>,
      cellRenderer: props => gridCellRenderer({ ...props, apiTargetInfo }),
    })

  const GridRef = useRef()

  return (
    <div
      style={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow
        style={{
          display: 'flex',
          //   justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            minWidth: '170px',
          }}
        >
          PI Monthly Summary
        </Title>
        {/* <label style={{ marginRight: '10px' }}>Date:</label> */}
        <DatePicker.MonthPicker
          allowClear={false}
          // mode="decade"
          value={selectedDate}
          // placeholder={['Start Date', 'End Date']}
          // open={openPicker}
          onChange={setSelectedDate}
          onPanelChange={setSelectedDate}
          format="MMMM-YYYY"
          style={{ minWidth: '150px' }}
        />

        <Select
          placeholder="Select Plant"
          style={{ minwidth: '230px', width: '230px', marginLeft: '20px' }}
          value={utility}
          onChange={v => {
            setUtility(utilityMap[v])
            setPlantId(v)
          }}
        >
          {R.sort((a, b) => a.localeCompare(b), Object.keys(utilityMap)).map(
            k => (
              <Select.Option key={k} value={k}>
                {utilityMap[k]}- {k}
              </Select.Option>
            )
          )}
        </Select>
        <Button
          style={{ marginLeft: '20px' }}
          primary
          onClick={onRetrieve}
          data-testid="criteria-retrieve"
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>
        {hasPiMonthlySummaryAccess && (
          <React.Fragment>
            <Button
              style={{ marginLeft: '20px' }}
              primary
              onClick={onSave}
              data-testid="criteria-retrieve"
              type="primary"
              icon="edit"
              disabled={editInfo.updated.length <= 0}
            >
              Save
            </Button>
            <Button
              style={{ marginLeft: '20px' }}
              primary
              onClick={onfiniliazeData}
              data-testid="criteria-retrieve"
              type="danger"
              disabled={editInfo.updated.length > 0}
              icon="thunderbolt"
            >
              Finalize Data
            </Button>
          </React.Fragment>
        )}
        <Filler />
        <Input.Search
          placeholder="Filter"
          style={{ marginLeft: '20px', maxWidth: '150px' }}
          data-testid="criteria-filter-input"
          value={fuzzyFilter}
          onChange={e => setFuzzyFilter(e.target.value)}
          icon="filter"
        />
        <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          btnStyle={{ marginLeft: '20px' }}
          headers={headers}
          data={data}
          fileName="Export"
          data-testid="criteria-export"
        />
      </CriteriaRow>

      <FullHeightSizer heightOffset={230}>
        {({ height, width }) => (
          <Content style={{ height }}>
            <Grid
              ref={GridRef}
              sortEnabled
              data={data}
              headers={headers}
              altBy={u => u.subGrpName}
              altBgColor="#ebebeb"
              // onEditInfoChange={info => editRow(info)}
              // editInfo={editInfo}
              // render={virtualizedGridRenderer({
              //   autoFixColByKey: true,
              //   rowHeaderRender,
              //   headerRowHeight: 30,
              //   height: height - 60,
              //   width: width - 50,
              // })}
              render={gridRenderer(apiTargetInfo, height - 50, width - 70)}
              mapEditRow={mapEditRow}
              fuzzyFilter={fuzzyFilter}
              isEditable={isEditable}
              selectionMode="single"
              selectionType="cell"
              editMode="cell"
              editInfo={editInfo}
              onEditInfoChange={editInfo => editRow(editInfo)}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(PiMonthlysummary)
